import gql from 'graphql-tag';
import { get } from 'lodash';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const QUERY = gql`
  query CustomerGeneratedWords($id: ID!, $startDate: ISO8601Date!, $endDate: ISO8601Date!) {
    customer(id: $id) {
      id
      histogram {
        generatedWords(startDate: $startDate, endDate: $endDate) {
          date
          value
        }
      }
    }
  }
`;

export const queryGeneratedWords = ({ customerId, startDate, endDate }) =>
  executeGqlQuery({
    query: QUERY,
    variables: { id: customerId, startDate, endDate },
  })
    .then(({ data }) => getSingleProp(data))
    .then((customer) => get(customer, 'histogram.generatedWords'));
